import { createLogic } from 'redux-logic'
import * as type from '../constants/commands'
import {
  syncSent, syncDone, syncFailed,
} from '../actions/commands'
import commandsChannel from '../api/commandsChannel'
import convertErrorToConsole from '../helpers/convertErrorToConsole'

const subscribeCommandsLogic = createLogic({
  type: type.SUBSCRIBE,
  cancelType: type.CANCEL_SUBSCRIBE,
  latest: true,
  warnTimeout: 0,

  process(_, dispatch) {
    commandsChannel({
      request: () => {
        dispatch(syncSent())
      },
      response: (data) => {
        const { error } = data
        if (error) {
          const fullError = convertErrorToConsole(error)
          window.store.dispatch(syncFailed(fullError))
        } else {
          window.store.dispatch(syncDone())
        }
      },
    })
  },
})

export default subscribeCommandsLogic
